import {
  MapTool,
  DataQuery,
  MapUtil,
  StringFilter,
  StringUtil
} from "cartovista";
import "../../css/Forage.css";﻿

    const forageCollapseHtml = '<div>' +
                                    '<select style="width:100%;margin-bottom:10px;" id="forage_dropDown">' +
                                    '<input style="width:100%;margin-bottom:10px;" id="forage_input" class="k-textbox cv-textBox">' +
                                    '<div style="width:100%;margin-bottom:10px;" id="forage_grid" class=""></div>' +
                                    '<button id="forage_cancelBtn" class="btn btn-sm btn-primary" style="width:calc(100% - 20px)">Annuler le forage</button>' +
                                '</div>';

    export default class Forage extends MapTool {
      constructor() {
        super($("#forage_btn")[0], {
            "map": window.cartovista.externalInterface.map, 
            "mapController": window.cartovista.getMapController(window.cartovista.externalInterface.map)
        }, {
            spriteCssClass: "cv-icon bootstrap-icon bi bi-joystick",
            toggleClassNames: "cv-state-active"
        });
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._divMap = this._mapController.divMap;
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        this._disabledThemeSets = typeof C.MAP_TOOLS.FORAGE.DISABLED_THEMESET != "undefined" ? C.MAP_TOOLS.FORAGE.DISABLED_THEMESET : [];
        this._targetLayersIds = _.union(_.reduce(C.MAP_TOOLS.FORAGE.TARGETS, function(layers, targetConfig) { return _.concat(layers, targetConfig.LAYERS); }, []));
        this._targetLayers = _.map(this._targetLayersIds, function(layerId){
            var layer = this._map.getLayer(layerId);
            layer.addEventListener(layer.EVENTS.VISIBLE_CHANGED, _.debounce(this._setDropDownDataSource, 300), this);
            layer.addEventListener(layer.EVENTS.ROLLOVER_CHANGED, _.debounce(this._onRolloverChanged, 300), this);
            return layer;
        }.bind(this));

        this._activeLayer = null;
        this._selectedFeatures = [];
        this._targetConfig = null;
        this._filteredLayers = null;

        this._$btn = $("#forage_btn");        
        window.cartovista.getUIController(this._map).cvToggleGroup.addElement(this);
        this._$arrowBtn = $("#forage_arrowBtn");
        this._$arrowBtn.click(this._onForageArrowBtnClicked.bind(this));
        this._$popup = $("#forage_container");
        this._$forageCollapse = $(forageCollapseHtml);
        this._$popup.append([this._$forageCollapse]);
        $(window).click(function(e) {this._$popup.addClass("cv-invisible"); this._$arrowBtn.removeClass("cv-state-active");}.bind(this));
        this._$popup.click(function(e){e.stopPropagation();});
        this._$cancelBtn = $("#forage_cancelBtn");
        this._$cancelBtn.click(this._onCancelBtnClicked.bind(this));
        this._$searchInput = $("#forage_input");
        this._$searchInput.on("input", _.debounce(this._onSearchInput.bind(this), 250));

        this._$kendoDropDown = this._$forageCollapse.find("#forage_dropDown").kendoDropDownList({
            "dataTextField": "name",
            "autoWidth": false,
            "popup": {
                "appendTo": this._$forageContainer
            },
            "change": this._activeLayerChanged.bind(this),
        }).data("kendoDropDownList");
        this._setDropDownDataSource();
        $("#forage_dropDown_listbox").click(function(e){e.stopPropagation();});

        this._$grid = this._$forageCollapse.find("#forage_grid");
        this._$kendoGrid = this._$grid.kendoGrid({
            columns: [{ field: "name" }],
            selectable: "multiple, row",
            rowTemplate: this._gridRowTemplate.bind(this),
            change: this._onGridChange.bind(this),
            dataBound: this._onGridDataBound.bind(this),
            height: 250,
            scrollable: false,
        }).data("kendoGrid");
      }

    _activated() {
        super._activated();
        $(this._divMap).on("click", this._onMapClick.bind(this));
        $(this._divMap).addClass("Forage_active");
    };

    _deactivated() {
        super._deactivated();
        this._$arrowBtn.removeClass("cv-state-active");
        $(this._divMap).off("click");
        $(this._divMap).removeClass("Forage_active");
    };

    _onThemeSetChanged() {
        if (!this._map.activeThemeSet || _.includes(this._disabledThemeSets, this._map.activeThemeSet.id)) {
            this.toggleOff();
            this._$btn.prop("disabled", true).addClass("k-state-disabled");
            this._$arrowBtn.prop("disabled", true).addClass("k-state-disabled");
        } else {
            this._$btn.prop("disabled", false).removeClass("k-state-disabled");
            this._$arrowBtn.prop("disabled", false).removeClass("k-state-disabled");
        }
    };

    _onCancelBtnClicked() {
        this._removeFilters();
        this._$grid.find("tr").removeClass("k-state-selected");
        this._selectedFeatures = [];
    };

    _onForageArrowBtnClicked(e) {
        e.stopPropagation();
        this._$popup.toggleClass("cv-invisible");
        this._$arrowBtn.toggleClass("cv-state-active");
        this.toggleOn();
    };

    _setDropDownDataSource() {
        var dataSource = _.reduce(this._targetLayers, function(dataSource, layer) {
            if(layer.visible){
                 dataSource.push({"name": layer.name, "id": layer.id});
            }
            return dataSource;
        }.bind(this), []);
        this._$kendoDropDown.setDataSource(dataSource);
        this._$kendoDropDown.select(0);
        this._$kendoDropDown.trigger("change");
    };

    _activeLayerChanged(e) {
        this._removeFilters();
        this._selectedFeatures = [];
        if(this._$kendoDropDown.dataItem()){
            this._activeLayer = this._map.getLayer(this._$kendoDropDown.dataItem().id);
            this._targetConfig = _.find(C.MAP_TOOLS.FORAGE.TARGETS, function(target){return _.includes(target.LAYERS, this._activeLayer.id);}.bind(this));
            this._filteredLayers = _.map(this._targetConfig.FILTERS, function(config){return this._map.getLayer(config.LAYER);}.bind(this));
            this._setGridDataSource();
        } else{
            this._activeLayer = null;
            this._targetConfig = null;
            this._filteredLayers = null;
        }
    };

    _setGridDataSource() {
        this._$searchInput.val("");
        var dataColumn = this._activeLayer.featureNameDataColumn;
        var dataTable = dataColumn.dataTable;
        var dataSource;
        new DataQuery([dataColumn]).execute(function(result) {
            dataSource = _.sortBy(_.map(result.linkingIds, function(linkingId, idx) {
                var name = linkingId + " - " + result.values[dataTable.id][dataColumn.id][idx];
                return {"id": linkingId, "name": name, "nameNoAccent": StringUtil.foldAccents(name)};
            }), "id");
            this._$kendoGrid.setDataSource(dataSource);
        }, this);
    };

    _onGridDataBound(e) {
        _.forEach(this._selectedFeatures, function(feature){
            var uid = this._$kendoGrid.dataSource.get(feature.id).uid;
            this._$grid.find("tr[data-uid='" + uid + "']").addClass("k-state-selected");
        }.bind(this));

        this._$grid.find("tr").hover(function(e){
            $(e.currentTarget).addClass("cv-state-hover");
            this._activeLayer.getSimpleFeatures([this._$kendoGrid.dataItem(e.currentTarget).id], function(result){
                this._activeLayer.rolloverFeatures = result.features
            }, this)
        }.bind(this), function(e){
            this._activeLayer.rolloverFeatures = [];
            $(e.currentTarget).removeClass("cv-state-hover");
        }.bind(this));
    };

    _gridRowTemplate(element) {
        var text = element.name;
        var value = StringUtil.foldAccents(this._$searchInput.val());
        if(value){
            var name = element.name,
                regex = new RegExp(value, "gi"),
                indexes = [],
                result;
            while(result = regex.exec(StringUtil.foldAccents(element.name))){
                indexes.push(result.index);
            }
            _.forEach(_.reverse(indexes), function(index){
                var beforeIndex = text.slice(0, index),
                    highlight = "<span class=cv-highlight>" + text.substr(index, value.length) + "</span>",
                    afterIndex = text.slice(index + value.length, text.length);
                text = beforeIndex + highlight + afterIndex;
            });
        }
        return '<tr data-uid="' + element.uid + '" role="row"><td role="gridcell" class="cv-dataGridCell-labelLeft">' + text + '</td></tr>';
    };

    _onGridChange(e) {
        var selectedIds = _.map(this._$kendoGrid.select(), function($item){
            return this._$kendoGrid.dataItem($item).id;
        }.bind(this));
        this._activeLayer.getSimpleFeatures(selectedIds, function(result){
            this._selectedFeatures = result.features;
        }, this);
        this._removeFilters();
        this._applyFilters();
    };

    _onSearchInput(e) {
        this._$kendoGrid.dataSource.filter({field: "nameNoAccent", operator: "contains", value: StringUtil.foldAccents(this._$searchInput.val())});
    };

    _onRolloverChanged(e) {
        this._$grid.find("tr").removeClass("cv-state-hover");
        if(!this._$popup.hasClass("cv-invisible") && e.source.id == this._activeLayer.id && e.source.rolloverFeatures){
            _.forEach(e.source.rolloverFeatures, function(feature){
                var uid = this._$kendoGrid.dataSource.get(feature.id).uid;
                this._$grid.find("tr[data-uid='" + uid + "']").addClass("cv-state-hover");
            }.bind(this));
        }
    };

    _onMapClick(e) {
        var MouseCoordinates = this.getNormalizedMouseCoordinates(e),
            x = Math.round(MapUtil.screenXtoMapX(MouseCoordinates.x, this._mapController._map.width, this._mapController._map.extent)),
            y = Math.round(MapUtil.screenYtoMapY(MouseCoordinates.y, this._mapController._map.height, this._mapController._map.extent));
        if(this._activeLayer){
            var radius = MapUtil.getSearchAtPointRadius(this._activeLayer, this._map);
            this._activeLayer.getFeatureOnTop(x, y, radius, function(result) {
                    //keep only features that are not filteredOut and visible
                    if (result.feature && !result.feature.filteredOut && result.feature.visible) {
                        if (e.shiftKey || e.ctrlKey){
                            if(_.includes(this._selectedFeatures, result.feature)){//remove feature already in collection
                                this._selectedFeatures = _.pull(this._selectedFeatures, result.feature);
                            } else{//add feature not in collection
                                this._selectedFeatures = _.union(this._selectedFeatures, [result.feature]);
                            }
                        } else{//single click replace the current selection
                            this._selectedFeatures = [result.feature];
                        }
                    }
            }, this);
        }
        this._removeFilters();
        this._applyFilters();
        this._$grid.find("tr").removeClass("k-state-selected");
        _.forEach(this._selectedFeatures, function(feature){
            var uid = this._$kendoGrid.dataSource.get(feature.id).uid;
            this._$grid.find("tr[data-uid='" + uid + "']").addClass("k-state-selected");
        }.bind(this));
    };

    _applyFilters() {
        var filters = _.map(this._selectedFeatures, function(item){ return new StringFilter("IS_EQUAL_TO", item.id)});
        _.forEach(this._filteredLayers, function(layer){
            var filteredLayerConfig = _.find(this._targetConfig.FILTERS, {"LAYER" : layer.id});
            var dataTable = layer.getDataTable(filteredLayerConfig.DATATABLE);
            var columnToFilter = dataTable.getDataColumns(filteredLayerConfig.DATACOLUMN)[0];
            columnToFilter.filterLogic = "or";
            columnToFilter.filters = filters;
        }.bind(this));
        this._mapController.zoomOnFeatures(this._selectedFeatures, this._activeLayer);
    };

    _removeFilters() {
        _.forEach(this._filteredLayers, function(layer){
            var filteredLayerConfig = _.find(this._targetConfig.FILTERS, {"LAYER" : layer.id});
            var dataTable = layer.getDataTable(filteredLayerConfig.DATATABLE);
            var columnToFilter = dataTable.getDataColumns(filteredLayerConfig.DATACOLUMN)[0];
            columnToFilter.clearFilters();
        }.bind(this));
    };

}
